import { apis } from '../api/index.js';

export async function institutionRecord(name, area) {
  const post = {};
  if (name) post.institutionName = name;
  if (area) post.areaProvince = area;
  let list = [];
  await apis.institutionRecord(post).then(res => {
    list = res.code === '0' ? res.data : [];
  });
  return list;
}

export async function getArea(id) {
  let list = [];
  await apis.getArea(id).then(res => {
    list = res.code === '0' ? res.data : [];
  });
  return list;
}

export async function instProjectInfo(page, size) {
  let list = [];
  let total = 0;
  await apis.instProjectInfo(page, size).then(res => {
    list = res.code === '0' ? res.data.list : [];
    total = res.code === '0' ? res.data.total : 0;
  });
  return { list, total };
}

export async function reportInfo(id) {
  let data = [];
  await apis.reportInfo(id).then(res => {
    data = res.code === '0' ? res.data : [];
  });
  return data;
}

export async function bodyPart() {
  let data = [];
  await apis.bodyPart().then(res => {
    data = res.code === '0' ? res.data : [];
  });
  return data;
}
export async function ctBodyPart(type) {
  let data = [];
  await apis.ctBodyPart(type).then(res => {
    data = res.code === '0' ? res.data : [];
  });
  return data;
}
